var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.145 11.9558L8.77109 1.67522C8.34711 0.989883 7.65271 0.999533 7.22868 1.68486L0.854716 11.9512C0.430744 12.6366 0.747576 13.166 1.55886 13.166H14.4403C15.2521 13.166 15.569 12.64 15.145 11.9558ZM7.99475 3.95064C8.40267 3.95064 8.71894 4.39676 8.69775 4.94207L8.56827 8.22765C8.54764 8.7724 8.28809 9.21851 7.99303 9.21851C7.6974 9.21851 7.43784 8.7724 7.41722 8.22765L7.28946 4.94207C7.26883 4.39676 7.58566 3.95064 7.99475 3.95064ZM7.99475 11.6933C7.47968 11.6933 7.12617 11.3209 7.13705 10.8118C7.13705 10.2915 7.49113 9.93038 7.99475 9.93038C8.51956 9.93038 8.85129 10.292 8.86276 10.8118C8.86218 11.3209 8.51957 11.6933 7.99475 11.6933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.cf0ed212ac949e09fd0a23310be7e145.svg";
export { ForwardRef as ReactComponent };